import { render, staticRenderFns } from "./Avulse.vue?vue&type=template&id=37619876&scoped=true"
import script from "./Avulse.vue?vue&type=script&lang=js"
export * from "./Avulse.vue?vue&type=script&lang=js"
import style0 from "./Avulse.vue?vue&type=style&index=0&id=37619876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37619876",
  null
  
)

export default component.exports